import createReducer from 'store/create-reducer';
import _ from 'lodash';
import apiFetch from 'utils/apiFetch';
import { loadingAction } from 'store/globalState/global';
import { joinInNodeRoom } from 'modules/socket/actions';
import { STATUS_INIT, STATUS_SUCCESS, STATUS_FAILURE } from 'constants/status';
import { TYPE_CALL_FOR_IMPACT } from 'constants/narratives';
import { ROOM_CALL_FOR_IMPACT } from 'constants/rooms';
import * as NOTIFICATIONS from 'constants/notifications';
import * as ACTION_TYPES from './types';

const INITIAL_STATE = {
  list: null,
  objectives: null,
  tools: null,
  elements: {},
  speedDating: null,
  speedDatingStatus: null,
  speedDatingError: null,
  speedDatingMatches: null,
  speedDatingMatchesStatus: null,
  speedDatingMatchesError: null,
  speedDatingCalls: null,
  speedDatingCallsStatus: null,
  speedDatingCallsError: null,
  resetComplete: null,
  myCallsForImpact: [],
  myCallsForImpactStatus: null,
  newUsersInNarratives: {},
};

export const fetchMainNarratives = () => (dispatch) => {
  dispatch(loadingAction(true));
  apiFetch('GET', { endPoint: 'narratives' })
    .then((narratives) => {
      dispatch(loadingAction(false));
      dispatch({ type: ACTION_TYPES.FETCH_NARRATIVES, narratives });
      narratives.forEach((narrative) => {
        if (narrative.type.id === TYPE_CALL_FOR_IMPACT) {
          joinInNodeRoom(ROOM_CALL_FOR_IMPACT, narrative.id);
        }
      });
    })
    .catch(() => {
      dispatch(loadingAction(false));
    });
};


export const fetchObjectives = () => (dispatch) => {
  dispatch(loadingAction(true));
  apiFetch('GET', { endPoint: 'objectives' })
    .then((objectives) => {
      dispatch(loadingAction(false));
      dispatch({ type: ACTION_TYPES.FETCH_OBJECTIVES, objectives });
    })
    .catch(() => {
      dispatch(loadingAction(false));
    });
};

export const fetchTools = () => (dispatch) => {
  dispatch(loadingAction(true));
  apiFetch('GET', { endPoint: 'main_tools' })
    .then((tools) => {
      dispatch(loadingAction(false));
      dispatch({ type: ACTION_TYPES.FETCH_TOOLS, tools });
    })
    .catch(() => {
      dispatch(loadingAction(false));
    });
};

export const fetchElements = (elementType, size = 20) => (dispatch) => {
  dispatch(loadingAction(true));
  apiFetch('GET', { endPoint: 'elements' }, { type: elementType, size })
    .then((elements) => {
      dispatch(loadingAction(false));
      dispatch({ type: ACTION_TYPES.FETCH_ELEMENTS, elements, elementType });
    })
    .catch(() => {
      dispatch(loadingAction(false));
    });
};

export const getNarrativeSpeedDating = narrativeId => (dispatch) => {
  dispatch(loadingAction(true));
  dispatch({ type: ACTION_TYPES.FETCH_SPEED_DATING_INIT });
  apiFetch('GET', { endPoint: `narratives/${narrativeId}/speed-dating` })
    .then((speedDating) => {
      dispatch(loadingAction(false));
      dispatch({ type: ACTION_TYPES.FETCH_SPEED_DATING_SUCCESS, speedDating });
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      dispatch({ type: ACTION_TYPES.FETCH_SPEED_DATING_FAILURE, error });
    });
};


export const getNarrativeSpeedDatingMatches = narrativeId => (dispatch) => {
  dispatch(loadingAction(true));
  dispatch({ type: ACTION_TYPES.FETCH_SPEED_DATING_MATCHES_INIT });
  apiFetch('GET', { endPoint: `narratives/${narrativeId}/speed-dating/matches` })
    .then((speedDatingMatches) => {
      dispatch(loadingAction(false));
      dispatch({ type: ACTION_TYPES.FETCH_SPEED_DATING_MATCHES_SUCCESS, speedDatingMatches });
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      dispatch({ type: ACTION_TYPES.FETCH_SPEED_DATING_MATCHES_FAILURE, error });
    });
};

export const connectInNarrativeSpeedDating = (narrativeId, userId) => {
  return apiFetch('POST', { endPoint: `narratives/${narrativeId}/speed-dating/connect` }, { user_id: userId });
};

export const getUserNarrativeSpeedDatingActualCalls = narrativeId => (dispatch) => {
  dispatch(loadingAction(true));
  dispatch({ type: ACTION_TYPES.FETCH_ACTUAL_SPEED_DATING_CALLS_INIT });
  apiFetch('GET', { endPoint: `narratives/${narrativeId}/speed-dating/calls` })
    .then((speedDatingCalls) => {
      dispatch(loadingAction(false));
      dispatch({ type: ACTION_TYPES.FETCH_ACTUAL_SPEED_DATING_CALLS_SUCCESS, speedDatingCalls });
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      dispatch({ type: ACTION_TYPES.FETCH_ACTUAL_SPEED_DATING_CALLS_FAILURE, error });
    });
};

export const resetNarrative = narrativeId => (dispatch) => {
  dispatch(loadingAction(true));
  dispatch({
    type: ACTION_TYPES.RESET_NARRATIVE_INIT,
  });

  apiFetch('POST', { endPoint: `narrative/${narrativeId}/reset` }, {})
    .then((response) => {
      dispatch({
        type: ACTION_TYPES.RESET_NARRATIVE_SUCCESS,
        payload: {
          response,
        },
      });
      dispatch(loadingAction(false));
    })
    .catch(() => {
      dispatch({
        type: ACTION_TYPES.RESET_NARRATIVE_FAILURE,
      });
      dispatch(loadingAction(false));
    });
};

export const getMyCallsForImpact = () => (dispatch) => {
  dispatch(loadingAction(true));
  dispatch({ type: ACTION_TYPES.GET_MY_CALLS_FOR_IMPACT_INIT });
  apiFetch('GET', { endPoint: 'callsforimpact/mine' })
    .then((myCallsForImpact) => {
      dispatch(loadingAction(false));
      dispatch({ type: ACTION_TYPES.GET_MY_CALLS_FOR_IMPACT_SUCCESS, myCallsForImpact });
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      dispatch({ type: ACTION_TYPES.GET_MY_CALLS_FOR_IMPACT_FAILURE, error });
    });
};

export const setNarrativeAsCompleted = narrativeId => (dispatch) => {
  dispatch({ type: ACTION_TYPES.SET_NARRATIVE_AS_COMPLETED, narrativeId });
};

export const cleanUsersFromNarrative = narrativeId => (dispatch) => {
  dispatch({ type: ACTION_TYPES.CLEAN_USERS_FROM_NARRATIVE, narrativeId });
};

const handleNodeNotifications = (state, notification) => {
  switch (notification.req_message) {
    case NOTIFICATIONS.NEW_USER_IN_IMPACT_EVENT: {
      const user = JSON.parse(notification.user);
      const narrativeId = parseInt(notification.narrative_id, 10);
      const newUsersInNarratives = { ...state.newUsersInNarratives };
      if (typeof newUsersInNarratives[narrativeId] === 'undefined') {
        newUsersInNarratives[narrativeId] = [];
      }
      if (!_.find(newUsersInNarratives[narrativeId], { id: user.id })) {
        newUsersInNarratives[narrativeId].push(user);
      }

      return {
        ...state,
        newUsersInNarratives,
      };
    }
    default:
      return state;
  }
};

const ACTION_HANDLERS = {
  [ACTION_TYPES.NOTIFICATION]: (state, { payload }) => handleNodeNotifications(state, payload),
  [ACTION_TYPES.NOTIFICATION_TO_ROOM]: (state, { payload }) => handleNodeNotifications(state, payload),
  [ACTION_TYPES.GET_MY_CALLS_FOR_IMPACT_INIT]: state => ({
    ...state,
    myCallsForImpactStatus: STATUS_INIT,
  }),
  [ACTION_TYPES.GET_MY_CALLS_FOR_IMPACT_SUCCESS]: (state, { myCallsForImpact }) => ({
    ...state,
    myCallsForImpact,
    myCallsForImpactStatus: STATUS_SUCCESS,
  }),
  [ACTION_TYPES.GET_MY_CALLS_FOR_IMPACT_FAILURE]: state => ({
    ...state,
    myCallsForImpactStatus: STATUS_FAILURE,
  }),
  [ACTION_TYPES.FETCH_NARRATIVES]: (state, { narratives }) => ({
    ...state,
    list: narratives,
  }),
  [ACTION_TYPES.FETCH_OBJECTIVES]: (state, { objectives }) => ({
    ...state,
    objectives,
  }),
  [ACTION_TYPES.FETCH_TOOLS]: (state, { tools }) => ({
    ...state,
    tools,
  }),
  [ACTION_TYPES.FETCH_ELEMENTS]: (state, { elements, elementType }) => {
    const stateElements = { ...state.elements };
    stateElements[elementType] = elements;
    return {
      ...state,
      elements: stateElements,
    };
  },
  [ACTION_TYPES.FETCH_SPEED_DATING_INIT]: state => ({
    ...state,
    speedDating: null,
    speedDatingStatus: STATUS_INIT,
    speedDatingError: null,
  }),
  [ACTION_TYPES.FETCH_SPEED_DATING_SUCCESS]: (state, { speedDating }) => ({
    ...state,
    speedDating,
    speedDatingStatus: STATUS_SUCCESS,
    speedDatingError: null,
  }),
  [ACTION_TYPES.FETCH_SPEED_DATING_FAILURE]: (state, { error }) => ({
    ...state,
    speedDating: null,
    speedDatingStatus: STATUS_FAILURE,
    speedDatingError: error,
  }),
  [ACTION_TYPES.FETCH_SPEED_DATING_MATCHES_INIT]: state => ({
    ...state,
    speedDatingMatches: null,
    speedDatingMatchesStatus: STATUS_INIT,
    speedDatingMatchesError: null,
  }),
  [ACTION_TYPES.FETCH_SPEED_DATING_MATCHES_SUCCESS]: (state, { speedDatingMatches }) => ({
    ...state,
    speedDatingMatches,
    speedDatingMatchesStatus: STATUS_SUCCESS,
    speedDatingMatchesError: null,
  }),
  [ACTION_TYPES.FETCH_SPEED_DATING_MATCHES_FAILURE]: (state, { error }) => ({
    ...state,
    speedDatingMatches: null,
    speedDatingMatchesStatus: STATUS_FAILURE,
    speedDatingMatchesError: error,
  }),
  [ACTION_TYPES.FETCH_ACTUAL_SPEED_DATING_CALLS_INIT]: state => ({
    ...state,
    speedDatingCalls: null,
    speedDatingCallsStatus: STATUS_INIT,
    speedDatingCallsError: null,
  }),
  [ACTION_TYPES.FETCH_ACTUAL_SPEED_DATING_CALLS_SUCCESS]: (state, { speedDatingCalls }) => ({
    ...state,
    speedDatingCalls,
    speedDatingCallsStatus: STATUS_SUCCESS,
  }),
  [ACTION_TYPES.FETCH_ACTUAL_SPEED_DATING_CALLS_FAILURE]: (state, { error }) => ({
    ...state,
    speedDatingCallsStatus: STATUS_FAILURE,
    speedDatingCallsError: error,
  }),
  [ACTION_TYPES.RESET_NARRATIVE_INIT]: state => ({
    ...state,
    resetComplete: null,
  }),
  [ACTION_TYPES.RESET_NARRATIVE_SUCCESS]: state => ({
    ...state,
    resetComplete: true,
  }),
  [ACTION_TYPES.RESET_NARRATIVE_FAILURE]: state => ({
    ...state,
    resetComplete: false,
  }),
  [ACTION_TYPES.SET_NARRATIVE_AS_COMPLETED]: (state, { narrativeId }) => {
    const newList = [...state.list];
    const index = _.findIndex(newList, { id: narrativeId });
    if (index >= 0) {
      newList[index].progress = 100;
    }
    return {
      ...state,
      list: newList,
    };
  },
  [ACTION_TYPES.CLEAN_USERS_FROM_NARRATIVE]: (state, { narrativeId }) => {
    const newUsersInNarratives = { ...state.newUsersInNarratives };
    if (typeof newUsersInNarratives[narrativeId] !== 'undefined') {
      delete newUsersInNarratives[narrativeId];
    }
    return {
      ...state,
      newUsersInNarratives: { ...newUsersInNarratives },
    };
  },
};

export default createReducer(INITIAL_STATE, ACTION_HANDLERS);



// WEBPACK FOOTER //
// ./src/routes/Narratives/modules/index.js